import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";
import { ITerm } from "ui/screens/plex-dictionary/term-translations";

import { IReleaseDetailsResponse, IMessage, IReleaseUpdateRequest } from "./ReleaseDetails.state";

const buildRequestConfig = (version: number) => ({
  headers: {
    "If-Match": `${version}`
  }
});

const createGetMessagesFilter = (filter: string) => {
  const params = new URLSearchParams();
  params.append("status", "paris-display-option-messageStatusPrerelease");
  filter && params.append("messageId", filter);

  return params;
};

const createGetTermsFilter = (filter: string) => {
  const params = new URLSearchParams();
  params.append("status", "paris-glossary-option-termStatusPrerelease");
  filter && params.append("filter", filter);

  return params;
};

export const getMessages = async (filter: string) =>
  (
    await getClientFor(mainApi.name).get<IMessage[]>(`/releases/messages`, {
      params: createGetMessagesFilter(filter)
    })
  ).data;

export const getReleaseDetails = async (releaseId: string) => (await getClientFor(mainApi.name).get<IReleaseDetailsResponse>(`/releases/${releaseId}`)).data;

export const getReleaseNameMessage = async (messageId: string) => (await getClientFor(mainApi.name).get<IMessage>(`/messages/${messageId}`)).data;

export const freezeRelease = async (releaseId: string) => await getClientFor(mainApi.name).post(`/releases/${releaseId}/freeze`, null, buildRequestConfig(1));

export const unfreezeRelease = async (releaseId: string) => await getClientFor(mainApi.name).post(`/releases/${releaseId}/unfreeze`, null, buildRequestConfig(1));

export const shipRelease = async (releaseId: string) => await getClientFor(mainApi.name).post(`/releases/${releaseId}/ship`, null, buildRequestConfig(1));

export const getAssociatedMessages = async (releaseId: string) => (await getClientFor(mainApi.name).get<IMessage[]>(`/releases/${releaseId}/messages`)).data;

export const stageMessage = async (releaseId: string, messageId: string, version: number) =>
  await getClientFor(mainApi.name).post(`/releases/${releaseId}/messages/${messageId}`, null, buildRequestConfig(version));

export const unstageMessage = async (releaseId: string, messageId: string, version: number) =>
  await getClientFor(mainApi.name).put(`/releases/${releaseId}/messages/${messageId}`, null, buildRequestConfig(version));

export const getAllTerms = async (filter: string) =>
  (
    await getClientFor(mainApi.name).get<ITerm[]>(`/terms`, {
      params: createGetTermsFilter(filter)
    })
  ).data;

export const getAssociatedTerms = async (releaseId: string) => (await getClientFor(mainApi.name).get<ITerm[]>(`/releases/${releaseId}/terms`)).data;

export const stageTerm = async (releaseId: string, termId: string, version: number) =>
  await getClientFor(mainApi.name).post(`/releases/${releaseId}/terms/${termId}`, null, buildRequestConfig(version));

export const unstageTerms = async (releaseId: string, termId: string, version: number) =>
  await getClientFor(mainApi.name).delete(`/releases/${releaseId}/terms/${termId}`, buildRequestConfig(version));

export const updateRelease = async (releaseId: string, model: IReleaseUpdateRequest) => {
  const response = await getClientFor(mainApi.name).post(`/releases/${releaseId}`, model);
  return response.data;
};
